<template>
  <div class="container-fluid default-dashboard pt-2">
    <div class="col-12">
      <div class="row">
        <div class="mb-3 d-flex justify-content-between row">
          <div class="col-md-3">
            <input v-model="params.start_date" class="form-control" type="datetime-local">
          </div>
          <div class="col-md-3">
            <input v-model="params.end_date" class="form-control" type="datetime-local">
          </div>
          <div class="col-md-2">
            <select v-model="params.divisi_id" class="form-select">
              <option value="">Select ALL Divisi</option>
              <option v-for="option in divisiOptions" :key="option.ID" :value="option.ID">{{
                (option as any).name }}</option>
            </select>
          </div>
          <div class="col-md-2">
            <select v-model="params.divisi_team_id" class="form-select">
              <option value="">Select ALL Divisi Team</option>
              <option v-for="option in divisiTeamOptions" :key="option.ID" :value="option.ID">{{
                (option as any).name }}</option>
            </select>
          </div>
          <div class="col-md-1">
            <button class="btn btn-primary w-100" type="button" @click="updateParams" title="Search">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="row general-widget">
            <Card1 colClass="col-3" cardClass="card widget-1" v-for="(item, index) in widgets as any" :key="index">
              <div class="widget-content">
                <div class="widget-round " :class="item.class">
                  <div class="bg-round">
                    <svg class="svg-fill">

                      <use :xlink:href="`/icon-sprite.svg#${item.svg1}`"></use>
                    </svg>
                    <svg class="half-circle svg-fill">
                      <use :xlink:href="`/icon-sprite.svg#${item.svg2}`"></use>
                    </svg>
                  </div>
                </div>
                <div>
                  <h4>{{ formatCurrency(item.number) }}</h4><span class="f-light">{{ item.title }}</span>
                </div>
              </div>
            </Card1>
          </div>
        </div>
        <div class="col-md-6">
          <MonthlyRevenue colClass="col-12" cardClass="card growthcard" :series="series2" :option="chartOptions2" />
        </div>
        <div class="col-12 col-md-6">
          <Card3 colClass="col-xxl-12" pre="true" cardhaderClass="card-no-border pb-0" preClass="mt-1 mb-0"
            headerTitle="true" title="Summary Rank">
            <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2 pb-2 p-0">
              <p class="mb-0"><em class="text-danger">chose your need information Rank</em></p>
              <ul class="nav nav-pills nav-warning" id="j-pills-tab" role="tablist">
                <li class="nav-item"><a class="nav-link active" id="rank-team-tab" data-bs-toggle="pill"
                    href="#rank-team" role="tab" aria-controls="rank-team" aria-selected="true">
                    Rank Team</a></li>
                <li class="nav-item"><a class="nav-link" id="rank-sales-tab" data-bs-toggle="pill" href="#rank-sales"
                    role="tab" aria-controls="rank-sales" aria-selected="false">Rank Sales</a></li>
                <li class="nav-item"><a class="nav-link" id="rank-customer-tab" data-bs-toggle="pill"
                    href="#rank-customer" role="tab" aria-controls="rank-customer" aria-selected="false">Rank
                    Customer</a></li>
              </ul>
            </div>
            <div class="card-body px-0 pb-0">
              <div class="tab-content">
                <div class="tab-pane fade justify-content-start show active" id="rank-team" role="tabpanel"
                  aria-labelledby="rank-team-tab" key="rank-team-tab">
                  <Card1 colClass="col-12" cardClass="card" cardhaderClass="card-no-border pb-0" title=""
                    headerTop="true" down="false" cardbodyClass="top-user pt-2">
                    <ul>
                      <li class="d-flex align-items-center justify-content-between gap-2"
                        v-for="(item, index) in teamDivisi" :key="index">
                        <div class="d-flex gap-2 py-1">
                          <div>
                            <a href="#">
                              <h6>{{ item.divisi_team_name }}</h6>
                            </a>
                            <p>Order: {{ formatSeparator(item.total_orders) }} ({{
                              formatSeparator(item.total_qty) }})</p>
                          </div>
                        </div>
                        <span>{{ formatCurrency(item.grand_total) }}</span>
                      </li>
                    </ul>
                  </Card1>
                </div>
                <div class="tab-pane fade justify-content-center" id="rank-sales" role="tabpanel"
                  aria-labelledby="rank-team-tab" key="rank-sales-tab">
                  <Card1 colClass="col-12" cardClass="card" cardhaderClass="card-no-border pb-0" title=""
                    headerTop="true" down="false" cardbodyClass="top-user pt-2">
                    <ul>
                      <li class="d-flex align-items-center justify-content-between gap-2" v-for="(item, index) in user"
                        :key="index">
                        <div class="d-flex gap-2 py-1">
                          <div class="flex-shrink-0 comman-round">
                          </div>
                          <div>
                            <a href="#">
                              <h6>{{ item.sales_name }}</h6>
                            </a>
                            <p>Order: {{ formatSeparator(item.total_orders) }} ({{
                              formatSeparator(item.total_qty) }})</p>
                          </div>
                        </div>
                        <span>{{ formatCurrency(item.grand_total) }}</span>
                      </li>
                    </ul>
                  </Card1>
                </div>
                <div class="tab-pane fade justify-content-end" id="rank-customer" role="tabpanel"
                  aria-labelledby="rank-team-tab" key="rank-customer-tab">
                  <Card1 colClass="col-12" cardClass="card" cardhaderClass="card-no-border pb-0" title=""
                    headerTop="true" down="false" cardbodyClass="top-user pt-2">
                    <ul>
                      <li class="d-flex align-items-center justify-content-between gap-2"
                        v-for="(item, index) in rankCustomer" :key="index">
                        <div class="d-flex gap-2 py-1">
                          <div>
                            <a href="#">
                              <h6>{{ item.customer_name }}</h6>
                            </a>
                            <p>Order: {{ formatSeparator(item.total_orders) }} ({{
                              formatSeparator(item.order_qty) }})</p>
                          </div>
                        </div>
                        <span>{{ formatCurrency(item.order_omset) }}</span>
                      </li>
                    </ul>
                  </Card1>
                </div>
              </div>
            </div>
          </Card3>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, watch, reactive, onMounted, defineAsyncComponent } from 'vue'
import Card3 from '@/components/common/card/CardData3.vue'
const MonthlyRevenue = defineAsyncComponent(() => import("@/components/common/MonthlyRevenue.vue"))
import { toast } from 'vue3-toastify'
import { useSessionStore } from '@/store/session';
const series2 = ref([
  {
    name: "Omset",
    data: [0, 0, 0, 0, 0, 0, 0, 0, 0]
  }
]);
const chartOptions2 = ref({
  chart: {
    height: 410,
    type: 'line',
    zoom: {
      enabled: false
    },
    toolbar: {
      show: false,
      tools: {
        download: false,
        selection: false,
        zoom: false,
        zoomin: false,
        zoomout: false,
        pan: false,
        reset: false
      }
    }
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    curve: 'straight'
  },
  grid: {
    row: {
      colors: ['#f3f3f3', 'transparent'],
      opacity: 0.5
    },
  },
  xaxis: {
    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],

    tooltip: {
      enabled: false
    }
  },
  yaxis: {
    labels: {
      formatter: function (value: number) {
        return new Intl.NumberFormat('id-ID').format(value);
      }
    }
  },
  tooltip: {
    y: {
      formatter: function (value: number) {
        return new Intl.NumberFormat('id-ID').format(value);
      }
    }
  }
});
const session = useSessionStore()
const rankCustomer = ref([] as any[])
const user = ref([] as any[])
const teamDivisi = ref([] as any[])
import * as sales from "@/api/services/SalesRequest";
const widgets = ref([
  {
    class: "danger",
    svg1: "cart",
    svg2: "halfcircle",
    number: "0",
    title: "Order",
    font: "font-danger",
    icon: "icon-arrow-up",
    total: "+50%"
  },
  {
    class: "primary",
    svg1: "tag",
    svg2: "halfcircle",
    number: "0",
    title: "Quantity",
    font: "font-primary",
    icon: "icon-arrow-up",
    total: "+70%"
  },
  {
    class: "secondary",
    svg1: "return-box",
    svg2: "halfcircle",
    number: "0",
    title: "Delivery",
    font: "font-secondary",
    icon: "icon-arrow-down",
    total: "-20%"
  },
  {
    class: "success",
    svg1: "rate",
    svg2: "halfcircle",
    number: "0",
    title: "Omset",
    font: "font-success",
    icon: "icon-arrow-up",
    total: "+70%"
  }
])
const Card1 = defineAsyncComponent(() => import("@/components/common/card/CardData1.vue"))
async function fetchDashboardAllSales() {
  user.value = []
  await sales.postRequest("/dashboard/sales-all", { ...params.value }).then((res) => {
    if (res.status == 200 && res.data) {
      if (res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          let dt = res.data[i];
          user.value.push(dt)
        }
      }
    }
  })
}
const fetchSalesDashboardTopDivisi = async () => {
  loading.value = true
  try {
    // Simulate API delay
    const paramstemp = session.getUser().role == "SALES" ? { ...params.value, email: session.getUser().email } : params
    await sales.postRequest("/dashboard/sales-team-rank", paramstemp.value).then((response) => {
      if (response.data) {
        teamDivisi.value = response.data
      }
    });

  } catch (error) {
    toast.error('Failed to fetch Team')
  }
  loading.value = false
}

const fetchSalesDashboardRankCustomer = async () => {
  loading.value = true
  try {
    // Simulate API delay
    const paramstemp = session.getUser().role == "SALES" ? { ...params.value, email: session.getUser().email } : params.value
    await sales.postRequest("/dashboard/sales-rank-customer", paramstemp.value).then((response) => {
      if (response.data) {
        rankCustomer.value = response.data
      }
    });
  } catch (error) {
    toast.error('Failed to fetch Customer')
  }
  loading.value = false
}

async function fetchDashboardAllSalesChartLine() {
  user.value = []
  await sales.postRequest("/dashboard/sales-chart-line", { ...params.value }).then((res) => {
    if (res.status == 200 && res.data) {
      if (res.data.length > 0) {
        // Extract months and omset data from response
        const months = res.data.map((item: any) => item.month.substring(0, 3)) // Get first 3 characters of month
        const omsetData = res.data.map((item: any) => item.order_omset)

        // Update series2 data
        series2.value[0].data = omsetData

        // Update chart categories
        chartOptions2.value.xaxis.categories = months
      }
    }
  })
}

const headers = [
  { text: 'Order No', value: 'code' },
  { text: 'Transaction Date', value: 'transaction_date' },
  { text: 'Divisi', value: 'divisi_team_name' },
  { text: 'Customer', value: 'customer_name' },
  { text: 'Payment', value: 'payment' },
  { text: 'Sales', value: 'sales_name' },
  { text: 'Status', value: 'order_status' },
  { text: 'QTY', value: 'qty_total' },
  { text: 'Grand Total', value: 'grand_total' },
]

const orderHistory = ref<any>([])
const loading = ref(false)
const total = ref(0)

const startdateQuery = ref(new Date().toISOString().split('T')[0] + " 00:00") // Initialize with prop value
const enddateQuery = ref(new Date().toISOString().split('T')[0] + " 23:59") // Initialize with prop value

const params = ref<any>({
  page: 1,
  size: 10,
  search: '',
  divisi_id: session.divisionOptions().find((d: any) => d.name === session.getUser().divisi)?.ID,
  divisi_team_id: '',
  divisi_name: session.divisionOptions().find((d: any) => d.name === session.getUser().divisi)?.name,
  start_date: startdateQuery.value,
  end_date: enddateQuery.value,

})

const updateParams = (newParams: any) => {
  Object.assign(params, newParams)
  fetchSalesDashboardTopDivisi()
  fetchSalesDashboardWidget()
  fetchDashboardAllSales()
  fetchDashboardAllSalesChartLine()
  fetchSalesDashboardRankCustomer()
}

function formatDateTime(dateString: string): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
}
function formatCurrency(value: number) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0
  }).format(value);
}

function formatSeparator(value: number): string {
  return new Intl.NumberFormat('id-ID', {
    style: 'decimal',
    minimumFractionDigits: 0
  }).format(value);
}

const fetchSalesDashboardWidget = async () => {
  loading.value = true
  try {
    // Simulate API delay
    let paramsTemp = { ...params.value }
    paramsTemp.start_date = paramsTemp.start_date ? new Date(paramsTemp.start_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T') : undefined
    paramsTemp.end_date = paramsTemp.end_date ? new Date(paramsTemp.end_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T') : undefined
    await sales.postRequest("/dashboard/sales-widget", {...paramsTemp}).then((response) => {
      if (response.data) {
        response.data.forEach((item: any) => {
          widgets.value[0].number = item.order_paid
          widgets.value[1].number = item.order_quantity
          widgets.value[2].number = item.order_delivery
          widgets.value[3].number = item.order_omset
        })
      }

      // warehouseDelivery.value = response.data;
      // total.value = response.total
    });

  } catch (error) {
    console.log(error)
    toast.error('Failed to fetch Sales')
  }
  loading.value = false
}

const divisiOptions = ref<{ ID: any }[]>([])
const divisiTeamOptions = ref<{ ID: any }[]>([])

watch(() => params.value.divisi_id, (newDivisi) => {
  divisiTeamOptions.value = session.divisionOptions().find((d: any) => d.ID === newDivisi)?.divisiTeams
  params.value.divisi_team_id = ""
})
onMounted(() => {
  // Inisialisasi chart jika perlu
  divisiOptions.value = session.divisionOptions()
  divisiTeamOptions.value = session.divisionOptions().find((d: any) => d.ID === params.value.divisi_id)?.divisiTeams
  fetchSalesDashboardTopDivisi()  
  fetchSalesDashboardWidget()
  fetchDashboardAllSales()
  fetchDashboardAllSalesChartLine()
  fetchSalesDashboardRankCustomer()
})
</script>